import { RiseOutlined } from '@ant-design/icons';
import classNames from 'classnames';
import React from 'react';
import styles from '../ROIAnalysisPanel.module.css';
import leadMagnetIcon from './lead-magnet-icon.png';
import openedEmailIcon from './opened-email-icon.png';
import XRayEmailIcon from './x-ray.png';

export const StatsCard = ({
  backgroundColor,
  captureRate,
  emailsCount,
  revenue,
  tag,
  withXray,
}) => {
  return (
    <div className={styles.statsCard} style={{ backgroundColor }}>
      <div
        className={classNames(styles.tag, { [styles.tagXray]: withXray })}
        style={{ border: `2px solid ${backgroundColor}` }}
      >
        {withXray && <img src={XRayEmailIcon} />}
        {tag}
      </div>
      <div className={styles.statRow}>
        <img src={leadMagnetIcon} className={styles.icon} />
        <div className={styles.statItem}>
          Email Captured Rate
          <span className={styles.boldText}>{captureRate}%</span>
        </div>
      </div>
      <div className={styles.statRow}>
        <img src={openedEmailIcon} className={styles.icon} />
        <div className={styles.statItem}>
          {withXray ? 'Additional Emails / mo' : 'Current Emails / mo'}
          <span className={styles.boldText}>{emailsCount}</span>
        </div>
      </div>
      <div className={styles.statRow}>
        <RiseOutlined className={styles.icon} />
        <div className={styles.statItem}>
          {withXray ? 'Additional Revenue' : 'Revenue from Emails'}
          <span
            className={classNames(styles.boldText, {
              [styles.textHighligted]: withXray,
            })}
          >
            ${revenue}
          </span>
        </div>
      </div>
      {withXray && <div className={styles.footerTag}>7.5x more</div>}
    </div>
  );
};
